/* cdn-cart.js — carrello laterale nello stile Martin (23-09-2026). Caricato in head.liquid, defer.
   1) «Aggiungi al tuo ordine» (cdn-cart-upsell): aggiunge il 50 ml con /cart/add.js e fa ricaricare il carrello del tema
      (evento theme:cart:refresh → righe e totali del tema; poi mp-club.js aggiorna Club, spedizione e suggerimenti).
   2) La riga della spedizione in cima (cdn-cart-goal) si aggiorna subito a ogni cambio, leggendo /cart.js,
      senza aspettare che arrivi la sezione nuova. */
(function () {
  'use strict';
  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  var money = function (cents) {
    var t = window.theme || {};
    if (typeof t.formatMoney === 'function') return t.formatMoney(cents, t.moneyFormat || '€{{amount_with_comma_separator}}');
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  };

  // ---------- 1. aggiungi dal carrello ----------
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cdn-up-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true;
    b.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-cdn-up-add')), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function () {
      b.classList.remove('is-loading');
      b.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    }).catch(function () {
      b.classList.remove('is-loading');
      b.classList.add('is-error');
      setTimeout(function () { b.classList.remove('is-error'); b.disabled = false; }, 2200);
    });
  });

  // ---------- 2. riga della spedizione, subito ----------
  var goalTimer = null;
  var updateGoal = function () {
    var goals = document.querySelectorAll('[data-cdn-goal]');
    if (!goals.length) return;
    clearTimeout(goalTimer);
    goalTimer = setTimeout(function () {
      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          goals.forEach(function (g) {
            var from = Number(g.getAttribute('data-from')) || 5000;
            var free = g.getAttribute('data-free') === 'true';
            var sub = cart.total_price || 0;
            var gap = from - sub;
            var done = free || gap <= 0;
            var pct = done ? 100 : Math.max(0, Math.min(100, Math.floor(sub * 100 / from)));
            var t = g.querySelector('[data-cdn-goal-t]'), bar = g.querySelector('[data-cdn-goal-bar]');
            if (t && !free) t.innerHTML = done ? g.getAttribute('data-t-done') : g.getAttribute('data-t-gap').replace('[amount]', money(gap));
            if (bar) bar.style.width = pct + '%';
            g.classList.toggle('is-done', done);
          });
        }).catch(function () {});
    }, 60);
  };
  ['theme:cart:change', 'theme:cart:add'].forEach(function (ev) { document.addEventListener(ev, updateGoal); });
})();
